// Package Imports
import React, { ReactNode } from 'react';
import { useTranslate } from '@refinedev/core';

// Project Imports
import usePermission from 'core/utils/usePermission';
import { useTokenContext } from 'contexts/resource/ResourceContext';
import AuthError from 'core/utils/AuthError';

type PrivateRouteProps = {
  children: ReactNode;
  name?: string;
};

const PrivateRoute = ({ children, name }: PrivateRouteProps) => {
  const checkPermission = usePermission();
  const t = useTranslate();
  const { token } = useTokenContext();
  let allowed = false;

  if (token && name && checkPermission(name)) {
    allowed = true;
  }

  let contentToShow: ReactNode;
  if (allowed) {
    contentToShow = children;
  } else if (token) {
    contentToShow = <AuthError message={t('pages.error.unAuthorized')} />;
  } else {
    contentToShow = <AuthError message={t('pages.error.unAuthenticated')} />;
  }

  return contentToShow;
};

export default PrivateRoute;
